module.exports = __webpack_public_path__ + "img/djnd-logo.a9ab0be3.svg";